import axios from 'axios';
import L from 'leaflet';
const mapContainer = document.querySelector('#stations-map');
const errorMsg = document.getElementById('error');
import { GestureHandling } from 'leaflet-gesture-handling';

if(mapContainer) {
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    const map = L.map('stations-map', {
        scrollWheelZoom: false,
        gestureHandling: true
    }).setView([51.505, -0.09], 15);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);


    const markerIcon = L.icon({
        iconUrl: '/site/images/mapmarker.png',
        iconSize: [19, 28],
        iconAnchor: [10, 24],
        popupAnchor: [0, 0],
    });

    const markers = [];
    const stations = document.querySelectorAll('.advocacy-card');

    for (let station of stations) {
        const ll = station.dataset.latlng.split(',');
        const points = [parseFloat(ll[0]), parseFloat(ll[1])];
        markers.push(
            L.marker(points, {icon: markerIcon})
                .bindPopup(station.innerHTML)
                .openPopup()
        );
    }

    const group = new L.featureGroup(markers).addTo(map);
    map.fitBounds(group.getBounds());


    mapContainer.addEventListener('displaymap', () => {
        map.invalidateSize();
        map.fitBounds(group.getBounds());
    });

}


/**
 * calculate distance between 2 points
 * @param lat1
 * @param lon1
 * @param lat2
 * @param lon2
 * @param unit
 * @returns {number}
 */
const distance = (lat1, lon1, lat2, lon2, unit) => {
    if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0;
    }
    else {
        const radlat1 = Math.PI * lat1/180;
        const radlat2 = Math.PI * lat2/180;
        const theta = lon1-lon2;
        const radtheta = Math.PI * theta/180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit==="K") { dist = dist * 1.609344 }
        if (unit==="N") { dist = dist * 0.8684 }
        return dist;
    }
};

/**
 * debounce AJAX calls
 * @param func
 * @param wait
 * @returns {Function}
 */
const debounce = (func, wait) => {
    var timeout;
    return function() {
        if (!timeout) func.apply(this, arguments);
        clearTimeout(timeout);
        timeout = setTimeout(()=>{timeout = null}, wait);
    };
};

/**
 * calculate distances for stations
 * @param fromPoint
 */
const calculateDistances = (fromPoint) => {
    const container = document.querySelector('.js-all-stations');
    const stations = document.querySelectorAll('.js-all-stations li');

    stations.forEach(station => {
        const toLL = station.dataset.latlng.split(',');

        const newDistance = distance(fromPoint.lat, fromPoint.lng, toLL[0], toLL[1]);

        station.dataset.distance = newDistance;
        if (!station.querySelector('.js-distance').classList.contains('show')) {
            station.querySelector('.js-distance').classList.add('show');
        }
        station.querySelector('.js-distance span').innerHTML = newDistance.toFixed(2) + ' miles away';
        station.dataset.innerhtml = station.innerHTML;
    });

    container.innerHTML = '';
    Array.from(stations).sort((a, b) => {
        const a1 = parseFloat(a.dataset.distance);
        const b1 = parseFloat(b.dataset.distance);
        return (a1 < b1 ? -1 : 1);
    }).forEach(el => {
        el.innerHTML = el.dataset.innerhtml;
        el.removeAttribute('data-innerhtml');
        container.appendChild(el);
    });
};

/**
 * do geolocation and update sortbys
 * @param e
 */
const getData = function(e) {
    e.preventDefault();
    const btnEl = form.querySelector('.form-search-button');
    btnEl.classList.toggle('loading');

    const field = form.querySelector('input[name="location"]');

    const url  ='https://geocode.search.hereapi.com/v1/geocode';
    const params = {
        apiKey: 'juiiPoG46n6ZctSChoFGWdZDBSq-pTDP0SNgDVlKB8A',
        q: `${field.value},United Kingdom`,
    };
    axios.get(url, { params: params })
        .then(response => {
            try {
                btnEl.classList.toggle('loading');
                const view = response.data.items[0];

                const ll = {
                    lat: view.position.lat,
                    lng: view.position.lng,
                };
                console.log(ll);
                calculateDistances(ll);
            } catch (error) {
                btnEl.classList.toggle('loading');
                errorMsg.innerHTML = error;
            }

        })
        .catch(error => {
            btnEl.classList.toggle('loading');
            errorMsg.innerHTML = error;
        });

};

const getLocation = function (e) {
    e.preventDefault();
    e.target.parentNode.classList.toggle('loading');

    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            e.target.parentNode.classList.toggle('loading');
            showPosition(position);
        }, function (error){
            e.target.parentNode.classList.toggle('loading');
            showError(error);
        });
    } else {
        e.target.classList.toggle('loading');
        errorMsg.innerHTML = 'Geolocation is not supported by this browser.';
    }
};

const showPosition = function (position) {
    const field = document.querySelector('input[name="location"]');
    field.value = 'My current location (' + position.coords.latitude + ', ' + position.coords.longitude +')';

    const ll = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
    };
    calculateDistances(ll);
};

const showError = function (error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            errorMsg.innerHTML = 'User denied the request for Geolocation.';
            break;
        case error.POSITION_UNAVAILABLE:
            errorMsg.innerHTML = 'Location information is unavailable.';
            break;
        case error.TIMEOUT:
            errorMsg.innerHTML = 'The request to get user location timed out.';
            break;
        case error.UNKNOWN_ERROR:
            errorMsg.innerHTML = 'An unknown error occurred.';
            break;
    }
};

// override form
const form = document.querySelector('.js-stations');
if (form) {
    form.addEventListener('submit', (e) => debounce(getData(e),200));
}
const myLocation = document.querySelector('.js-my-location');
if (myLocation) {
    myLocation.addEventListener('click', (e) => getLocation(e));
}